import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface ICardModuleProps {
  background?: string;
  bgColor?: string;
}

export const Container = styled(Link)<ICardModuleProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1.5rem;
  backdrop-filter: ${props => props.theme.cards.backdropFilter};
  border-radius: ${props => props.theme.radius.primary};
  border: 1px solid ${props => props.theme.cards.border};
  width: 100%;
  height: 100%;
  color: #ffffff;
  background-image: ${props => props.background ? `url(${props.background})` : 'none'};
  background-color: ${props => props.bgColor || props.theme.cards.primary};
  background-position: -24px center;
  background-size: cover !important;
  background-repeat: no-repeat;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.05) 0rem 1.25rem 1.6875rem 0rem;
  transition: all 1s cubic-bezier(0.19, 1, 0.22, 1);
  min-height: 164px;
  text-decoration: none;

  @media (max-width: 768px) {
    flex: 1;
  }

  &:hover {
    cursor: pointer;
    background-position: -5% center;
    
    &:before {
      opacity: 1;
      background-image: linear-gradient(90deg, #000, transparent);
      backdrop-filter: blur(2px);
    }

    a svg {
      margin-left: 0.25rem;
    }
  }



  > header {

    > div {
      margin-bottom: 0.5rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      > h2 {
        color: #ffffff;
        font-size: 1.5rem;
      }
    }
  
    > p { 
      color: ${props => props.theme.colors.muted};
      font-size: 12px;
      font-weight: 400;
    }
  }

  > footer {

    > a {
      display: flex;
      align-items: center;
      flex-direction: row;
      color: ${props => props.theme.colors.muted};
      text-decoration: none;
      text-transform: uppercase;
      font-size: 12px;
      letter-spacing: 3px;

      > svg {
        font-size: 18px;
        transition: all .2s ease-in-out;
      }
    }
  }

`;

export const IconBg = styled.div`
  position: absolute;
  bottom: -25px;
  right: -25px;
  width: 150px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: -1;
`;